import { render, staticRenderFns } from "./ImageModal.vue?vue&type=template&id=1235a28b&scoped=true"
import script from "./ImageModal.vue?vue&type=script&lang=js"
export * from "./ImageModal.vue?vue&type=script&lang=js"
import style0 from "./ImageModal.vue?vue&type=style&index=0&id=1235a28b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1235a28b",
  null
  
)

export default component.exports